<template>
    <ModalComponent
        name="add-base"
        title="Crear nueva base"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Nombre" name="nombre" rules="required" rows="3" v-model="nombre" />
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: [],
        data() {
            return {
                nombre: null,
                loading: false
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'add-base', creado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crear();
                }
            },
            crear() {
                this.loading = true;

                const params = {
                    filters : {},
                    nombre: this.nombre
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.crear'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
